/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface RetellService {
  /**
   * @summary Handle Inbound Call
   * @description Retell inbound call webhook.
   *
   * Expects payload like:
   * {
   *   "event": "call_inbound",
   *   "call_inbound": { "agent_id": "...", "from_number": "+1...", "to_number": "+1..." }
   * }
   *
   * Returns (2xx) with optional fields under call_inbound:
   * {
   *   "call_inbound": {
   *     "override_agent_id": "...",
   *     "override_agent_version": 1,
   *     "dynamic_variables": { "_current_time": "03:45 PM", "user_number": "+1..." },
   *     "metadata": { ... }
   *   }
   * }
   */
  handleInboundCallRetellInboundPost: {
    /**
     * @summary Handle Inbound Call
     * @description Retell inbound call webhook.
     *
     * Expects payload like:
     * {
     *   "event": "call_inbound",
     *   "call_inbound": { "agent_id": "...", "from_number": "+1...", "to_number": "+1..." }
     * }
     *
     * Returns (2xx) with optional fields under call_inbound:
     * {
     *   "call_inbound": {
     *     "override_agent_id": "...",
     *     "override_agent_version": 1,
     *     "dynamic_variables": { "_current_time": "03:45 PM", "user_number": "+1..." },
     *     "metadata": { ... }
     *   }
     * }
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        HandleInboundCallRetellInboundPostBody,
        HandleInboundCallRetellInboundPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: HandleInboundCallRetellInboundPostSchema,
        options: ServiceOperationMutationFnOptions<
          HandleInboundCallRetellInboundPostBody,
          HandleInboundCallRetellInboundPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<HandleInboundCallRetellInboundPostData, HandleInboundCallRetellInboundPostError>>
    ): Promise<RequestFnResponse<HandleInboundCallRetellInboundPostData, HandleInboundCallRetellInboundPostError>>;
    /**
     * @summary Handle Inbound Call
     * @description Retell inbound call webhook.
     *
     * Expects payload like:
     * {
     *   "event": "call_inbound",
     *   "call_inbound": { "agent_id": "...", "from_number": "+1...", "to_number": "+1..." }
     * }
     *
     * Returns (2xx) with optional fields under call_inbound:
     * {
     *   "call_inbound": {
     *     "override_agent_id": "...",
     *     "override_agent_version": 1,
     *     "dynamic_variables": { "_current_time": "03:45 PM", "user_number": "+1..." },
     *     "metadata": { ... }
     *   }
     * }
     */
    getMutationKey(
      parameters: DeepReadonly<HandleInboundCallRetellInboundPostParameters> | void
    ): ServiceOperationMutationKey<
      HandleInboundCallRetellInboundPostSchema,
      HandleInboundCallRetellInboundPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Inbound Call
     * @description Retell inbound call webhook.
     *
     * Expects payload like:
     * {
     *   "event": "call_inbound",
     *   "call_inbound": { "agent_id": "...", "from_number": "+1...", "to_number": "+1..." }
     * }
     *
     * Returns (2xx) with optional fields under call_inbound:
     * {
     *   "call_inbound": {
     *     "override_agent_id": "...",
     *     "override_agent_version": 1,
     *     "dynamic_variables": { "_current_time": "03:45 PM", "user_number": "+1..." },
     *     "metadata": { ... }
     *   }
     * }
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.retellService.handleInboundCallRetellInboundPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.retellService.handleInboundCallRetellInboundPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends HandleInboundCallRetellInboundPostBody, TContext = unknown>(
      parameters: DeepReadonly<HandleInboundCallRetellInboundPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        HandleInboundCallRetellInboundPostSchema,
        HandleInboundCallRetellInboundPostData,
        HandleInboundCallRetellInboundPostParameters,
        TVariables,
        OperationError<HandleInboundCallRetellInboundPostError>,
        TContext
      >
    ): UseMutationResult<
      HandleInboundCallRetellInboundPostData,
      OperationError<HandleInboundCallRetellInboundPostError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Inbound Call
     * @description Retell inbound call webhook.
     *
     * Expects payload like:
     * {
     *   "event": "call_inbound",
     *   "call_inbound": { "agent_id": "...", "from_number": "+1...", "to_number": "+1..." }
     * }
     *
     * Returns (2xx) with optional fields under call_inbound:
     * {
     *   "call_inbound": {
     *     "override_agent_id": "...",
     *     "override_agent_version": 1,
     *     "dynamic_variables": { "_current_time": "03:45 PM", "user_number": "+1..." },
     *     "metadata": { ... }
     *   }
     * }
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.retellService.handleInboundCallRetellInboundPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.retellService.handleInboundCallRetellInboundPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        HandleInboundCallRetellInboundPostBody,
        HandleInboundCallRetellInboundPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        HandleInboundCallRetellInboundPostSchema,
        HandleInboundCallRetellInboundPostData,
        HandleInboundCallRetellInboundPostParameters,
        TVariables,
        OperationError<HandleInboundCallRetellInboundPostError>,
        TContext
      >
    ): UseMutationResult<
      HandleInboundCallRetellInboundPostData,
      OperationError<HandleInboundCallRetellInboundPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Handle Inbound Call
     * @description Retell inbound call webhook.
     *
     * Expects payload like:
     * {
     *   "event": "call_inbound",
     *   "call_inbound": { "agent_id": "...", "from_number": "+1...", "to_number": "+1..." }
     * }
     *
     * Returns (2xx) with optional fields under call_inbound:
     * {
     *   "call_inbound": {
     *     "override_agent_id": "...",
     *     "override_agent_version": 1,
     *     "dynamic_variables": { "_current_time": "03:45 PM", "user_number": "+1..." },
     *     "metadata": { ... }
     *   }
     * }
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const handleInboundCallRetellInboundPostTotal = qraft.retellService.handleInboundCallRetellInboundPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const handleInboundCallRetellInboundPostTotal = qraft.retellService.handleInboundCallRetellInboundPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            HandleInboundCallRetellInboundPostBody,
            HandleInboundCallRetellInboundPostData,
            HandleInboundCallRetellInboundPostParameters,
            OperationError<HandleInboundCallRetellInboundPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleInboundCallRetellInboundPostSchema,
            HandleInboundCallRetellInboundPostBody,
            HandleInboundCallRetellInboundPostData,
            HandleInboundCallRetellInboundPostParameters,
            OperationError<HandleInboundCallRetellInboundPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Handle Inbound Call
     * @description Retell inbound call webhook.
     *
     * Expects payload like:
     * {
     *   "event": "call_inbound",
     *   "call_inbound": { "agent_id": "...", "from_number": "+1...", "to_number": "+1..." }
     * }
     *
     * Returns (2xx) with optional fields under call_inbound:
     * {
     *   "call_inbound": {
     *     "override_agent_id": "...",
     *     "override_agent_version": 1,
     *     "dynamic_variables": { "_current_time": "03:45 PM", "user_number": "+1..." },
     *     "metadata": { ... }
     *   }
     * }
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const handleInboundCallRetellInboundPostPendingMutationVariables = qraft.retellService.handleInboundCallRetellInboundPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const handleInboundCallRetellInboundPostMutationData = qraft.retellService.handleInboundCallRetellInboundPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        HandleInboundCallRetellInboundPostData,
        OperationError<HandleInboundCallRetellInboundPostError>,
        MutationVariables<HandleInboundCallRetellInboundPostBody, HandleInboundCallRetellInboundPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            HandleInboundCallRetellInboundPostBody,
            HandleInboundCallRetellInboundPostData,
            HandleInboundCallRetellInboundPostParameters,
            OperationError<HandleInboundCallRetellInboundPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleInboundCallRetellInboundPostSchema,
            HandleInboundCallRetellInboundPostBody,
            HandleInboundCallRetellInboundPostData,
            HandleInboundCallRetellInboundPostParameters,
            OperationError<HandleInboundCallRetellInboundPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          HandleInboundCallRetellInboundPostData,
          OperationError<HandleInboundCallRetellInboundPostError>,
          MutationVariables<HandleInboundCallRetellInboundPostBody, HandleInboundCallRetellInboundPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Handle Inbound Call
     * @description Retell inbound call webhook.
     *
     * Expects payload like:
     * {
     *   "event": "call_inbound",
     *   "call_inbound": { "agent_id": "...", "from_number": "+1...", "to_number": "+1..." }
     * }
     *
     * Returns (2xx) with optional fields under call_inbound:
     * {
     *   "call_inbound": {
     *     "override_agent_id": "...",
     *     "override_agent_version": 1,
     *     "dynamic_variables": { "_current_time": "03:45 PM", "user_number": "+1..." },
     *     "metadata": { ... }
     *   }
     * }
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            HandleInboundCallRetellInboundPostBody,
            HandleInboundCallRetellInboundPostData,
            HandleInboundCallRetellInboundPostParameters,
            OperationError<HandleInboundCallRetellInboundPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleInboundCallRetellInboundPostSchema,
            HandleInboundCallRetellInboundPostBody,
            HandleInboundCallRetellInboundPostData,
            HandleInboundCallRetellInboundPostParameters,
            OperationError<HandleInboundCallRetellInboundPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Handle Inbound Call
     * @description Retell inbound call webhook.
     *
     * Expects payload like:
     * {
     *   "event": "call_inbound",
     *   "call_inbound": { "agent_id": "...", "from_number": "+1...", "to_number": "+1..." }
     * }
     *
     * Returns (2xx) with optional fields under call_inbound:
     * {
     *   "call_inbound": {
     *     "override_agent_id": "...",
     *     "override_agent_version": 1,
     *     "dynamic_variables": { "_current_time": "03:45 PM", "user_number": "+1..." },
     *     "metadata": { ... }
     *   }
     * }
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.retellService.handleInboundCallRetellInboundPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.retellService.handleInboundCallRetellInboundPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              HandleInboundCallRetellInboundPostBody,
              HandleInboundCallRetellInboundPostData,
              HandleInboundCallRetellInboundPostParameters,
              OperationError<HandleInboundCallRetellInboundPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleInboundCallRetellInboundPostSchema,
              HandleInboundCallRetellInboundPostBody,
              HandleInboundCallRetellInboundPostData,
              HandleInboundCallRetellInboundPostParameters,
              OperationError<HandleInboundCallRetellInboundPostError>,
              TContext
            >
      ):
        | Mutation<
            HandleInboundCallRetellInboundPostData,
            HandleInboundCallRetellInboundPostError,
            MutationVariables<HandleInboundCallRetellInboundPostBody, HandleInboundCallRetellInboundPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              HandleInboundCallRetellInboundPostBody,
              HandleInboundCallRetellInboundPostData,
              HandleInboundCallRetellInboundPostParameters,
              OperationError<HandleInboundCallRetellInboundPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleInboundCallRetellInboundPostSchema,
              HandleInboundCallRetellInboundPostBody,
              HandleInboundCallRetellInboundPostData,
              HandleInboundCallRetellInboundPostParameters,
              OperationError<HandleInboundCallRetellInboundPostError>,
              TContext
            >
      ): Array<
        Mutation<
          HandleInboundCallRetellInboundPostData,
          HandleInboundCallRetellInboundPostError,
          MutationVariables<HandleInboundCallRetellInboundPostBody, HandleInboundCallRetellInboundPostParameters>,
          TContext
        >
      >;
    };
    schema: HandleInboundCallRetellInboundPostSchema;
    types: {
      parameters: HandleInboundCallRetellInboundPostParameters;
      data: HandleInboundCallRetellInboundPostData;
      error: HandleInboundCallRetellInboundPostError;
      body: HandleInboundCallRetellInboundPostBody;
    };
  };
}
/**
 * @summary Handle Inbound Call
 * @description Retell inbound call webhook.
 *
 * Expects payload like:
 * {
 *   "event": "call_inbound",
 *   "call_inbound": { "agent_id": "...", "from_number": "+1...", "to_number": "+1..." }
 * }
 *
 * Returns (2xx) with optional fields under call_inbound:
 * {
 *   "call_inbound": {
 *     "override_agent_id": "...",
 *     "override_agent_version": 1,
 *     "dynamic_variables": { "_current_time": "03:45 PM", "user_number": "+1..." },
 *     "metadata": { ... }
 *   }
 * }
 */
export const handleInboundCallRetellInboundPost = {
  schema: {
    method: 'post',
    url: '/retell/inbound',
  },
} as {
  schema: HandleInboundCallRetellInboundPostSchema;
  [QraftServiceOperationsToken]: RetellService['handleInboundCallRetellInboundPost'];
};
export const retellService = {
  handleInboundCallRetellInboundPost,
} as const;
type HandleInboundCallRetellInboundPostSchema = {
  method: 'post';
  url: '/retell/inbound';
};
type HandleInboundCallRetellInboundPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type HandleInboundCallRetellInboundPostData =
  paths['/retell/inbound']['post']['responses']['200']['content']['application/json'];
type HandleInboundCallRetellInboundPostError = unknown;
type HandleInboundCallRetellInboundPostBody = undefined;
